// common
export const PUT_REQUEST = 'appointmentNotes/PUT_REQUEST'
export const PUT_SUCCESS = 'appointmentNotes/PUT_SUCCESS'
export const PUT_FAILURE = 'appointmentNotes/PUT_FAILURE'